import { RequestTypesKeys } from '@app/enums/RequestTypes';
import { getTravelRequestEnumStringValue, TravelRequestEnum } from '@app/enums/travel-request.enum';
import { IRowNode } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { CurrencyViewModel } from '@models/currency';
import { PaymentRequestStatus, RequestStatusNames, TravelRequestStatus } from '@models/request';
import { StudyExpense, VisitName } from '@models/study';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';

export function dateComparator(valueA: string, valueB: string) {
    if (!valueA) return 1;
    if (!valueB) return -1;

    const d1 = new Date(valueA);
    const d2 = new Date(valueB);
    if (d1 === d2) return 0;
    return d1 > d2 ? 1 : -1;
}

export function visitNameComparator(valueA: VisitName, valueB: VisitName) {
    if (!valueA) return 1;
    if (!valueB) return -1;
    if (valueA.name === valueB.name) return 0;
    return valueA.name > valueB.name ? 1 : -1;
}

export function localCurrencyComparator(valueA: CurrencyViewModel, valueB: CurrencyViewModel) {
    if (!valueA) return 1;
    if (!valueB) return -1;
    if (valueA.isocode === valueB.isocode) return 0;
    return valueA.isocode > valueB.isocode ? 1 : -1;
}

export function requestStatusComparator(
    valueA: number,
    valueB: number,
    nodeA: IRowNode<StudyExpenseTrackingDataRow>,
    nodeB: IRowNode<StudyExpenseTrackingDataRow>
) {
    if (!nodeA || !nodeB) return;
    const requestTypeA = (nodeA.data as StudyExpenseTrackingDataRow).requestType;
    let statusAString = '';
    if (requestTypeA === RequestTypesKeys.TRAVEL) {
        statusAString = RequestStatusNames[TravelRequestStatus[valueA]];
    } else {
        statusAString = RequestStatusNames[PaymentRequestStatus[valueA]];
    }

    const requestTypeB = (nodeB.data as StudyExpenseTrackingDataRow).requestType;
    let statusBString = '';
    if (requestTypeB === RequestTypesKeys.TRAVEL) {
        statusBString = RequestStatusNames[TravelRequestStatus[valueB]];
    } else {
        statusBString = RequestStatusNames[PaymentRequestStatus[valueB]];
    }

    return statusAString?.localeCompare(statusBString, undefined, { sensitivity: 'base' });
}

export function expenseTypeComparator(
    valueA: StudyExpense | TravelRequestEnum,
    valueB: StudyExpense | TravelRequestEnum,
    nodeA: IRowNode<StudyExpenseTrackingDataRow>,
    nodeB: IRowNode<StudyExpenseTrackingDataRow>
) {
    const requestTypeA = (nodeA?.data as StudyExpenseTrackingDataRow)?.requestType;
    let expenseTypeAString = '';
    if (requestTypeA === RequestTypesKeys.TRAVEL) {
        expenseTypeAString = getTravelRequestEnumStringValue(valueA as TravelRequestEnum);
    } else {
        if (requestTypeA === RequestTypesKeys.STIPEND) return 1;
        expenseTypeAString = (valueA as StudyExpense)?.expenseDefaultValue;
    }

    const requestTypeB = (nodeB?.data as StudyExpenseTrackingDataRow)?.requestType;
    let expenseTypeBString = '';
    if (requestTypeB === RequestTypesKeys.TRAVEL) {
        expenseTypeBString = getTravelRequestEnumStringValue(valueB as TravelRequestEnum);
    } else {
        if (requestTypeB === RequestTypesKeys.STIPEND) return -1;
        expenseTypeBString = (valueB as StudyExpense)?.expenseDefaultValue;
    }

    return expenseTypeAString?.localeCompare(expenseTypeBString, undefined, { sensitivity: 'base' }) ?? 0;
}
